export default __webpack_public_path__ + "static/media/fontainebleau11.a2d8c8c1.jpg";